<template>
  <v-app-bar
    v-scroll="onScroll"
    app
    elevate-on-scroll
    :color="!isScrolling ? 'rgba(255,255,255,0.2)' : 'grey lighten-3'"
  >
    <v-btn
      to="/"
      class="home-image"
      elevation="0"
      style="background-color: transparent"
    >
      <v-img
        contain
        class="shrink"
        max-height="50px"
        src="/static/gamboa-logo-largo-v2.svg"
      />
    </v-btn>
    <v-spacer />
    <template v-if="$vuetify.breakpoint.mdAndUp">
      <v-btn
        v-for="(item, i) in items"
        :key="i"
        :to="item.to"
        class="text-capitalize subtitle-1 mx-1"
        text
      >
        <span
          v-if="!$store.state.langSwitch"
          :class="!isScrolling ? 'white--text' : 'black--text'"
          v-text="item.text"
        />
        <span
          v-else
          :class="!isScrolling ? 'white--text' : 'black--text'"
          v-text="item.textEnglish"
        />
      </v-btn>
    </template>
    <v-menu v-else>
      <template v-slot:activator="{ on }">
        <v-btn
          icon
          v-on="on"
        >
          <v-icon>mdi-dots-vertical</v-icon>
        </v-btn>
      </template>
      <v-card
        color="primary"
        dark
      >
        <v-list color="transparent">
          <v-list-item
            v-for="(item, i) in items"
            :key="i"
            :to="item.to"
          >
            <v-list-item-title v-text="item.text" />
          </v-list-item>
        </v-list>
      </v-card>
    </v-menu>
    <div
      style="width: 120px;"
      class="pt-5"
    >
      <v-switch
        v-model="$store.state.langSwitch"
        :label="$store.state.langSwitch ? 'English' : 'Español'"
        color="primary"
        @change="onSwitch"
      />
    </div>
  </v-app-bar>
</template>

<script>
  // Utilities
  import { mapMutations } from 'vuex'
  import i18next from 'i18next'

  export default {
    data: () => ({
      isScrolling: false,
      items: [
        {
          to: '/',
          text: 'Inicio',
          textEnglish: 'Home'
        },
        {
          to: '/nuestros-servicios',
          text: 'Nuestros Servicios',
          textEnglish: 'Our Services'
        },
        {
          to: '/nuestro-equipo',
          text: 'Nuestro Equipo',
          textEnglish: 'Our Team'
        },
        {
          to: '/contacto',
          text: 'Contacto',
          textEnglish: 'Contact Us'
        }
      ]
    }),

    methods: {
      ...mapMutations(['toggleDrawer']),
      onScroll () {
        this.isScrolling = (window.pageYOffset ||
          document.documentElement.scrollTop || 0) > 20
      },
      onSwitch () {
        this.$store.state.langSwitch ? i18next.changeLanguage('en') : i18next.changeLanguage('es')
      }
    }
  }
</script>

<style scoped>
.home-image:before {
  content: none;
}
</style>
